export type TemplatesLibrarySection = 'layouts' | 'email' | 'notifications' | 'documents';

export type TemplatesHeaderState =
  | {
      mode: 'library';
      section: TemplatesLibrarySection;
      searchQuery: string;
      syncing?: boolean;
      error?: string | null;
    }
  | {
      mode: 'material-editor';
      title: string;
      subtitle: string;
      dirty: boolean;
      saving: boolean;
      canPublish: boolean;
    }
  | {
      mode: 'message-editor';
      title: string;
      subtitle: string;
      channel: 'email' | 'notification';
      dirty: boolean;
      saving: boolean;
      resetting: boolean;
      preview: boolean;
      canReset: boolean;
    };

export const TEMPLATES_HEADER_STATE_EVENT = 'templates:header-state-change';
export const TEMPLATES_HEADER_REQUEST_EVENT = 'templates:header-request-state';
export const TEMPLATES_SEARCH_EVENT = 'templates:search-change';
export const TEMPLATES_BACK_EVENT = 'templates:back';
export const TEMPLATES_SAVE_EVENT = 'templates:save';
export const TEMPLATES_RESET_EVENT = 'templates:reset';
export const TEMPLATES_PREVIEW_EVENT = 'templates:toggle-preview';

export function publishTemplatesHeaderState(state: TemplatesHeaderState | null) {
  window.dispatchEvent(new CustomEvent<TemplatesHeaderState | null>(
    TEMPLATES_HEADER_STATE_EVENT,
    { detail: state },
  ));
}
